import { createSelector } from 'reselect';

import { getAllChannels } from 'store/programs/selectors/channels.selectors';

import { selectLoanChannelId } from './loanApplicationCommonInfo.selectors';

export const selectActiveChannelConfig = createSelector(
  [getAllChannels, selectLoanChannelId],
  (channels, loanChannelId) => {
    if (!loanChannelId) {
      return null;
    }

    return channels.find(channel => channel.channelId === loanChannelId) ?? null;
  },
);

export const selectChannelSectionVisibilityMap = createSelector(
  [selectActiveChannelConfig],
  channelConfig =>
    (channelConfig?.sectionVisibilities ?? []).reduce(
      (acc, { section, visibility }) => ({ ...acc, [section]: visibility }),
      {},
    ),
);
